/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Bulldozer by Poly by Google [CC-BY] (https://creativecommons.org/licenses/by/3.0/) via Poly Pizza (https://poly.pizza/m/ddxtaegI3HQ)
*/
import { useSpring } from '@react-spring/three'
import { Center, useGLTF, useMatcapTexture } from '@react-three/drei'
import type { ObjectMap } from '@react-three/fiber'
import { CuboidCollider, RapierRigidBody, RigidBody } from '@react-three/rapier'
import { useEffect, useRef, useState, type JSX } from 'react'
import { Material, MeshMatcapMaterial, Vector3, type Mesh, type MeshStandardMaterial } from 'three'
import { type GLTF } from 'three-stdlib'

type GLTFResult = GLTF &
  ObjectMap & {
    nodes: {
      Box003_1: Mesh
      Box003_1_1: Mesh
      Box003_1_2: Mesh
      Box003_1_3: Mesh
      Box003_1_4: Mesh
    }
    materials: {
      ['03___Default']: MeshStandardMaterial
      ['07___Default']: MeshStandardMaterial
      ['19___Default']: MeshStandardMaterial
      ['01___Default']: MeshStandardMaterial
      ['09___Default']: MeshStandardMaterial
    }
  }

export function Bulldozer(props: JSX.IntrinsicElements['group']) {
  const { nodes, materials } = useGLTF('/models/bulldozer.glb') as GLTFResult

  const [matcap] = useMatcapTexture('7A7A7A_D9D9D9_BCBCBC_B4B4B4', 64)
  const [overriddenMaterials, setOverriddenMaterials] = useState<Record<string, Material>>()

  const ref = useRef<RapierRigidBody>(null)

  useEffect(() => {
    setOverriddenMaterials({
      '03___Default': new MeshMatcapMaterial({ matcap, color: materials['03___Default'].color }),
      '07___Default': new MeshMatcapMaterial({ matcap, color: materials['07___Default'].color }),
      '19___Default': new MeshMatcapMaterial({ matcap, color: materials['19___Default'].color }),
      '01___Default': new MeshMatcapMaterial({ matcap, color: materials['01___Default'].color }),
      '09___Default': new MeshMatcapMaterial({ matcap, color: materials['09___Default'].color }),
    })
  }, [materials, matcap])

  useSpring({
    from: { positionX: 8, positionZ: -5.6 },
    to: { positionX: 4, positionZ: -1.6 },
    config: { duration: 4500 },
    onChange: v => {
      if (!ref.current) return
      ref.current.setTranslation(new Vector3(v.value.positionX, 1, v.value.positionZ), true)
    },
  })

  return (
    overriddenMaterials && (
      <group {...props} dispose={null}>
        <group position-y={1}>
          <RigidBody ref={ref} colliders={false} type="kinematicPosition">
            <CuboidCollider args={[1.6, 1, 1]} />
            <Center scale={0.1}>
              <group>
                <mesh
                  geometry={nodes.Box003_1.geometry}
                  material={overriddenMaterials['03___Default']}
                />
                <mesh
                  geometry={nodes.Box003_1_1.geometry}
                  material={overriddenMaterials['07___Default']}
                />
                <mesh
                  geometry={nodes.Box003_1_2.geometry}
                  material={overriddenMaterials['19___Default']}
                />
                <mesh
                  geometry={nodes.Box003_1_3.geometry}
                  material={overriddenMaterials['01___Default']}
                />
                <mesh
                  geometry={nodes.Box003_1_4.geometry}
                  material={overriddenMaterials['09___Default']}
                />
              </group>
            </Center>
          </RigidBody>
        </group>
      </group>
    )
  )
}

useGLTF.preload('/models/bulldozer.glb')
